export function isTricastOrForecastMarket(market?: any) {
  return market?.type === 'tricast' || market?.type === 'forecast';
}

export function resolveSelectionFields(selection: any, raceFields: any[] = []) {
  if (!selection?.race_field_ids?.length || !raceFields?.length) return [];

  const fieldMap = new Map(raceFields.map((field) => [field.field_id, field]));

  return selection.race_field_ids
    .map((fieldId: number) => fieldMap.get(fieldId))
    .filter(Boolean);
}

export function formatFieldDisplayName(field?: { number?: string | number; name?: string }) {
  if (!field) return '';

  const name = field.name?.trim() ?? '';
  if (field.number != null && field.number !== '') {
    return name ? `${field.number} ${name}` : `${field.number}`;
  }

  return name;
}

export function getSelectionDisplayName(selection: any, raceFields: any[] = []) {
  const fields = resolveSelectionFields(selection, raceFields);

  if (fields.length > 1) {
    return fields.map((field) => formatFieldDisplayName(field)).join(' - ');
  }

  if (fields.length === 1) {
    return formatFieldDisplayName(fields[0]);
  }

  return selection?.name ?? '';
}

export function normalizeSelections(
  selections: any[] = [],
  raceFields: any[] = [],
  market?: any,
) {
  const useHorseDisplayName = isTricastOrForecastMarket(market);

  return selections.map((selection) => ({
    id: selection.id,
    name: selection.name,
    num: selection.num,
    price: selection.price,
    result: selection.result,
    suspended: selection.suspended,
    closed: selection.closed,
    bet_closed: selection.bet_closed,
    prices_history: selection.prices_history,
    race_field_ids: selection.race_field_ids,
    fields: resolveSelectionFields(selection, raceFields),
    displayName: useHorseDisplayName
      ? getSelectionDisplayName(selection, raceFields)
      : selection.name,
  }));
}

export function isSingleFieldSelection(selection: any) {
  return selection?.race_field_ids?.length === 1;
}
